// This page shows the available sources selection
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { collection, query, orderBy, getDocs } from 'firebase/firestore';
import { db } from '../../config/firebase';
import './Tips.css';

const TipsSourceCard = ({ source, onSelect, disabled }) => (
  <div 
    className={`tips-source-card ${disabled ? 'disabled' : ''}`}
    onClick={disabled ? null : () => onSelect(source.id)}
  >
    <h2>{source.name}</h2>
    <p>{source.description}</p>
    <span className="source-date">{source.date}</span>
    {disabled && (
      <span className="coming-soon-badge">Kommer snart</span>
    )}
  </div>
);

function PreTipsPage() {
  const [availableSources, setAvailableSources] = useState([]);
  const [sourcesLoading, setSourcesLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchAvailableSources = async () => {
      setSourcesLoading(true);
      try {
        const tipsQuery = query(
          collection(db, 'TipsLists'),
          orderBy('addedAt', 'desc')
        );
        
        const snapshot = await getDocs(tipsQuery);
        
        const sources = snapshot.docs.map(doc => ({
          id: doc.id,
          name: doc.data().source || 'Unknown Source',
          description: doc.data().description || `${doc.data().source}s filmtips`,
          date: doc.data().addedAt ? new Date(doc.data().addedAt.toDate()).toLocaleDateString('sv-SE') : 'Nytt',
          disabled: doc.data().disabled || false
        }));
        
        setAvailableSources(sources);
      } catch (error) {
        console.error('Error in fetchAvailableSources:', error);
        setError('Could not load available sources');
      } finally {
        setSourcesLoading(false);
      }
    };

    fetchAvailableSources();
  }, []);

  const handleSourceSelect = (sourceId) => {
    navigate(`/tips`, { 
      state: { sourceId },
      replace: true // This prevents going back to source selection when clicking back from show details
    });
  };

  return (
    <div className="tips-container">
      <div className="tips-sources-wrapper">
        <h1>Välj tipskälla</h1>
        {sourcesLoading ? (
          <div className="tips-sources-grid">
            {[1].map((_, index) => (
              <div key={index} className="tips-source-card-skeleton">
                <div className="title-skeleton"></div>
                <div className="description-skeleton"></div>
                <div className="date-skeleton"></div>
              </div>
            ))}
          </div>
        ) : (
          <div className="tips-sources-grid">
            {availableSources.length > 0 ? (
              availableSources.map(source => (
                <TipsSourceCard
                  key={source.id}
                  source={source}
                  onSelect={() => handleSourceSelect(source.id)}
                  disabled={source.disabled}
                />
              ))
            ) : (
              <div className="no-sources-message">
                Inga tipskällor tillgängliga
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default PreTipsPage; 